export default {
    i18n: {
        "Http": "HTTP",
        "handset": "Handenhet",
        "day": "Dag",
        "auto": "Auto",
        "bluetooth": "Bluetooth",
        "Device Information": "Enhetsinformation",
        "Device Name": " Enhetsnamn",
        "Group": "Group",
        "Volume": "Volym",
        "tamperAlarm": "Manipuleringslarm",
        "Card": "Kort",
        "Fingerprint": "Fingeravtryck",
        "Date Time": "Datum och tid",
        "name": "namn",
        "minutes": "minuter",
        "timezone": "tidszon",
        "Are you sure you want to delete this device?": "Är du säker på att du vill ta bort den här enheten?",
        "Attendance Point Name": "Närvaropunktsnamn",
        "Mac": "MAC",
        "confirmToDeleteIt?": "Bekräfta borttagning?",
        "captureLogs": "Bildlogg",
        "Doors": "Dörrar",
        "All Doors": "Alla dörrar",
        "Lock List": "Låslista",
        "Link Device Relay": "Länkenhetsrelä",
        "Added Successfully!": "Tillagd framgångsrikt !",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "När låset är kopplat till ett relä låses låset upp när reläet utlöses.",
        "Adding...": "Tillägg ?",
        "Please try again 24 hours later.": "Vänligen försök igen 24 timmar senare.",
        "Action": "Åtgärd",
        "unlock": "Lås upp",
        "Address": "Adress",
        "Owner": "Ägare",
        "Failed": "Misslyckades",
        "Timeout": "Timeout",
        "Response": "Svar",
        "caller": "Uppringare",
        "receiver": "Mottagare",
        "doorLogs": "Dörrlogg",
        "callHistory": "Samtalshistorik",
        "UID": "UID",
        "Call Type": "Samtalstyp",
        "Code": "Kod",
        "User": "Användare",
        "Device List": "Monitor lista",
        "Time": "Tid",
        "Company": "Företag",
        "Property Managers": "Fastighetsförvaltare",
        "Current Version": "Nuvarande version",
        "indoorMonitor": "Monitor för inomhusbruk",
        "guardPhone": " Vakttelefon",
        "close": "Stäng",
        "Success": "Framgång",
        "URL": "URL",
        "Please select a device.": "Vänligen välj en enhet",
        "Password is too weak.": "Lösenordet är för svagt.",
        "Company is required.": "Vänligen ange företagsnamn",
        "Your account is not activated, please contact your service provider.": "Ditt konto är inte aktiverat, kontakta din tjänsteleverantör.",
        "Language": "Språk",
        "Face": "Ansikte",
        "Please set at least one access type.": "Vänligen ange minst en typ av tillträde.",
        "Please contact your service provider to activate this advanced feature.": "Kontakta tjänsteleverantör för att aktivera denna avancerade funktion.",
        "Community name": "Områdesnamn",
        "Please enable PM App first.": "Aktivera först fastighetsförvaltarens app.",
        "Username": "Användarnamn",
        "Change Log": "Ändringslogg",
        "Assign": "Tilldela",
        "Floor": "Våning",
        "Link Device": "Koppla enhet",
        "Accessible Floors": "Tillgängliga våningar",
        "Upgrade": "Uppgradering",
        "Function": "Funktion",
        "callDuration": "Samtalslängd",
        "No": "Nej",
        "Verification Code": " Verifieringskod",
        "Expiration Time": "Utgångstid",
        "PIN": "PIN-KOD",
        "MAC": "MAC",
        "Building": "Byggnad",
        "APT": "LGH",
        "ID": "ID",
        "Name": "Namn",
        "activities": "Aktiviteter",
        "Obtain": "Hämta",
        "call": "ring",
        "Group Call": "Gruppsamtal",
        "Delete": "Tabort",
        "Yes": "Ja",
        "Door Release PIN": "Dörröppnings-PIN",
        "Email": "E-post",
        "Mobile Number doesn\'t exist.": "Mobilnumret finns inte.",
        "Tips": "Tips",
        "Password": "Lösenord",
        "The end time cannot be earlier than the start time.": "Sluttiden kan inte vara tidigare än starttiden.",
        "Back": "Tillbaka",
        "File format error.": "Filformatsfel.",
        "motionDetection": "Rörelsedetektering",
        "You are trying too often, please try again in 5 minutes": "Du försöker för ofta, vänligen försök igen om 5 minuter.",
        "User name too long.": "Användarnamn för långt. Max 63 tecken.",
        "This MAC address is redirected on RPS.": "Denna MAC-adress omdirigeras i RPS.",
        "No Answer": "Inget svar",
        "failedToUnlock": "Misslyckades att låsa upp",
        "visitor": "besökare",
        "yesterday": "Igår",
        "Too large data! Please first export the data before %s first,thanks.": "Data är för stor! Exportera först data före %s, tack.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Kontrollera om det finns obetalda beställningar. Om inte, kontakta din tjänsteleverantör.",
        "lock": "Lås",
        "open": "Öppna",
        "The PersonalAccount is not active.": "Personalkontot är inte aktivt.",
        "You cannot link an account that already link other accounts.": "Du kan inte länka ett konto som redan är länkat till andra konton.",
        "You cannot link multiple property manager accounts under the same installer account.": "Du kan inte länka flera fastighetsförvaltarkonton under samma installatörskonto.",
        "You cannot link to the currently logged in account.": "Du kan inte länka till det konto du är inloggad på.",
        "nfc": "NFC",
        "Delete Device": "Ta bort enhet",
        "date": "datum",
        "Device deleted successfully": "Enheten har raderats framgångsrikt",
        "Failed to delete device": "Det gick inte att radera enheten",
        "Are you sure you want to cancel?": "Är du säker på att du vill avbryta?",
        "Unlimited": "Obegränsad",
        "Battery Level": "Batterinivå",
        "Password Incorrect.": "Fel lösenord.",
        "deliverySystemVerification": "Leveransverifiering",
        "None": "Inget",
        "Upgrading...": "Uppgraderar...",
        "amenityReservation": "Bokning av gemensamhetsutrymme",
        "idAccess": "ID-åtkomst",
        "exitButton": "Utgångsknapp",
        "Please select at least one item.": "Vänligen välj minst ett objekt.",
        "The ID can contain only digits and letters, up to 32 characters.": "ID får endast innehålla siffror och bokstäver, max 32 tecken.",
        "The PIN is not available.": "PIN-koden är inte tillgänglig.",
        "Change WiFi": "Byt WiFi",
        "Access Denied.": "Tillträde beviljas ej.",
        "Model": "Modell",
        "RF Card": "RF kort",
        "Phone number": "Telefonnummer",
        "Invalid {0}.": "Ogiltigt {0}.",
        "{0} already exists.": "{0} finns redan.",
        "Operation failed!": "Åtgärden misslyckades!",
        "Failed to get data.": "Misslyckades hämta data.",
        "You do not have the necessary permissions to perform this operation.": "Du saknar behörighet för denna åtgärd.",
        "You can only import one template at a time in the current site.": "Du kan bara importera en mall åt gången på denna plats.",
        "Delivery name": "Leveransnamn",
        "MAC address not in the MAC library.": "MAC-adressen finns inte i MAC-biblioteket.",
        "Please delete devices under this building.": "Ta bort enheter under denna byggnad först.",
        "The start time cannot be later than the end time.": "Starttiden får inte vara senare än sluttiden.",
        "emergency action type": "Typ av nödfallsåtgärd",
        "Only 1000 data items can be imported at a time.": "Max 1000 poster kan importeras åt gången.",
        "The password is too short.": "Lösenordet är för kort.",
        "The data has been updated. Please refresh the page and try again.": "Data har uppdaterats, vänligen ladda om sidan och försök igen.",
        "AutoP length must be less 2048 bytes.": "AutoP-kommandot måste vara mindre än 2048 byte.",
        "File Check Failed": "Filgranskning misslyckades",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Administratörskontots inloggning har gått ut. Vänligen kontakta din tjänsteleverantör.",
        "iqPinVerificationFailed": "IQ PIN-verifiering misslyckades.",
        "accountBlacklisted": "Kontot är svartlistat.",
        "outsideAuthorizedTime": "Utanför auktoriserad tid.",
        "network group": "nätverksgrupp",
        "Company name": "Företagsnamn",
        "Group name": "Gruppnamn",
        "relay": "relä",
        "motionTime": "rörelsedetekteringstid",
        "motionType": "rörelsedetekteringstyp",
        "postalCode": "postnummer",
        "floor format": "våningsformat",
        "mobilePhone": "mobiltelefon",
        "time format": "tidsformat",
        "security relay": "säkerhetsrelä",
        "Param": "Parameter",
        "Offline Code": "Offline-kod",
        "Add akubela Smart Locks": "Lägg till akubela smartlås",
        "Module Version": "Modulversion",
        "Lock Body Version": "Låshus-version",
        "Available Version": "Tillgänglig version",
        "Please wake up the lock screen and then upgrade.": "Väck låsskärmen och uppgradera sedan.",
        "This process will take some time, please be patient.": "Den här processen tar en stund, var god vänta.",
        "Please confirm that the WiFi network is functioning properly.": "Vänligen bekräfta att WiFi-nätverket fungerar korrekt.",
        "Please wake up the lock screen.": "Vänligen väck låsskärmen.",
        "This lock has already been added to another apartment.": "Detta lås har redan lagts till i en annan lägenhet.",
        "This lock has already been added to the apartment.": "Detta lås har redan lagts till på lägenheten.",
        "Pin Code": "PIN-kod",
        "Too many failed attempts, please try again in a few minutes.": "För många misslyckade försök, försök igen om några minuter.",
        "Login Account": "Inloggningskonto",
        "Same account cannot login in different ins.": "Samma konto kan inte användas på flera olika installatörer.",
        "Lock Name": "Låsnamn",
        "Smart Locks": "Smartlås",
        "Add Smart Lock": "Lägg till smartlås",
        "The selected duration cannot be more than one year.": "Den valda perioden kan inte vara längre än ett år.",
        "The end time of the break time cannot be later than the end work time.": "Rastens sluttid får inte vara senare än arbetstidens slut.",
        "The start time of the break time cannot be earlier than the start work time.": "Rastens starttid får inte vara tidigare än arbetstidens start.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Sluttiden för giltig stämpling får inte vara före arbetstidens slut.",
        "The start time of the valid check time cannot be later than the start work time.": "Starttiden för giltig stämpling får inte vara efter arbetstidens start.",
        "Deleting failed. The timetable is used by a shift.": "Borttagningen misslyckades. Schemat används av ett arbetspass.",
        "Deleting failed. The shift is in use.": "Borttagningen misslyckades. Arbetspasset används.",
        "Deleting failed. The leave type is in use.": "Borttagningen misslyckades. Ledighetstypen används.",
        "Valid time conflicts with an existing schedule.": "Giltig tid krockar med befintligt schema.",
        "The timing for multiple schedules must not coincide.": "Tider för flera scheman får inte överlappa.",
        "Attendance Log": "Närvarologg",
        "Added Failed!": "Tillagd misslyckades!",
        "Setting WiFi": "Ställer in WiFi",
        "License Plate": "Registreringsskylt",
        "key": "Nyckel",
        "IQ Offline.": "IQ offline.",
        "{0}Unlock": "{0} upplåsning",
        "automatically": "Automatiskt",
        "manually": "Manuellt",
        "Video Storage": "Videolagring",
        "Device(s) for Video Storage": "Enhet(er) för videolagring",
        "The amount of exported data is too large. Please export it in batches.": "Exporterat datamängd är för stor. Exportera i omgångar.",
        "Auto-record video when door unlocks": "Spela in video automatiskt vid upplåsning av dörr",
        "Auto-record video during calls": "Spela in video automatiskt under samtal",
        "Manual video recording in monitoring": "Manuell videoinspelning vid övervakning",
        "Saved for 30days/60days/90days": "Sparas i 30/60/90 dagar",
        "To subscribe, please contact your provider for activation.": "För att prenumerera, kontakta din leverantör för aktivering.",
        "Saved for {0}days": "Sparas i {0} dagar",
        "Subscribed Plan": "Abonnemangsplan",
        "Supported Devices: {0}": "Stödda enheter: {0}",
        "{0}Lock": "{0} låsning",
        "Video Saving": "Videolagring",
        "Download Completed!": "Nedladdning klar!",
        "Fail to download.": "Nedladdning misslyckades.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Radering misslyckades! Fastighetsförvaltaren är kopplad till en RentManager-kund, du bör ta bort den först.",
        "No log to be exported.": "Ingen logg att exportera.",
        "capture&Video": "Bild & Video",
        "packageDetection": "Paketdetektering",
        "Time format is invalid.": "Tidsformatet är ogiltigt.",
        "No permission to export logs of this type.": "Du har inte behörighet att exportera denna loggtyp.",
        "Project type is invalid.": "Projekttyp är ogiltig.",
        "Salto Account Blocked.": "Salto-konto blockerat.",
        "Remote open not in access group.": "Fjärröppning ej tillåten utanför behörighetsgruppen.",
        "SIP Account required.": "SIP-konto krävs.",
        "The PIN must be {0} digits.": "PIN-koden måste bestå av {0} siffror.",
        "gatewayConnectionUnavailable": "Gateway-anslutning ej tillgänglig.",
        "Invalid Username or Password": "Ogiltigt användarnamn eller lösenord.",
        "Account already linked to another user.": "Konto redan länkat till en annan användare.",
        "The account has been added by another user.": "Kontot har lagts till av en annan användare.",
        "Failed to add. This user already has 5 license plates.": "Kunde inte lägga till. Användaren har redan 5 registreringsskyltar.",
        "Please at least select a door.": "Vänligen välj minst en dörr.",
        "UHF Card": "UHF-kort",
        "personnel": "personal",
        "Parking Lot Name": "Parkeringsnamn",
        "Controlled Relay": "Styrd relä",
        "No Permission": "Ingen behörighet",
        "Please ensure that all doors in the project are activated at the same time.": "Vänligen aktivera alla dörrar i projektet samtidigt.",
        "gatewayBusy": "Gateway upptagen",
        "Please set the perimeter door group first.": "Vänligen ställ in perimeterdörrgruppen först.",
        "Please ensure that all doors in the project are renewed at the same time.": "Se till att alla dörrar förnyas samtidigt i projektet.",
        "When lockdown is on, the controlled relay cannot be modified.": "Vid låsningsläge kan styrd relä inte ändras.",
        "DetectionLogs": "Detekteringsloggar",
        "packageIn": "Paket in",
        "packageOut": "Paket ut",
        "View Progress": "Visa förlopp",
        "Check if the WiFi is operating on the 2.4GHz band.": "Kontrollera om WiFi-nätverket använder 2,4 GHz-bandet.",
        "Verify that the WiFi password is correct.": "Verifiera att WiFi-lösenordet är korrekt.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Säkerställ att du är ansluten till rätt enhets hotspot under hotspot-konfigurationen.",
        "Offline Code Unlock": "Lås upp med offline-kod",
        "Salto Token Expired.": "Salto-token har gått ut.",
        "Lock Offline": "Låset är offline",
        "identity information! Please login again": "Identitetsinformation! Logga in igen.",
        "Email is required.": "E-postadress krävs.",
        "Mobile number is required.": "Mobilnummer krävs.",
        "You can\'t make payments for offices in different time zones.": "Du kan inte göra betalningar för kontor i olika tidszoner.",
        "The current scheduling staff exceeds 200 people.": "Nuvarande personalplanering överskrider 200 personer.",
        "param": "parameter",
        "Invalid UserName or Password": "Ogiltigt användarnamn eller lösenord",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Ditt Salto KS-konto har inte behörighet att ändra låsets namn.",
        "Owner is required.": "Ägare krävs.",
        "Office is required.": "Kontor krävs.",
        "PIN or RF Card is required.": "PIN eller RF-kort krävs.",
        "RF card": "RF-kort",
        "Personnel is required.": "Personal krävs.",
        "email address": "e-postadress",
        "mobile number": "mobilnummer",
        "The length must be less than 32 characters.": "Längden måste vara mindre än 32 tecken.",
        "The length must be less than 256 characters.": "Längden måste vara mindre än 256 tecken.",
        "Access Group is required.": "Åtkomstgrupp krävs.",
        "Device is required.": "Enhet krävs.",
        "Admin is required.": "Admin krävs.",
        "Mobile number": "Mobilnummer",
        "schedules": "scheman",
        "Timetable name": "Schemanamn",
        "Shift name": "Skiftnamn",
        "Leave type": "Ledighetstyp",
        "recheck in time": "åter-incheckningstid",
        "recheck out time": "åter-utcheckningstid",
        "The building name": "Byggnadsnamn",
        "Building is required.": "Byggnad krävs.",
        "selection, The same reader cannot be set for both entry and exit": "val, Samma läsare kan inte ställas in för både in- och utgång",
        "Door number": "Dörrnummer",
        "door input cannot be selection duplicated.": "Dörringången kan inte väljas dubbelt.",
        "Group is required.": "Grupp krävs.",
        "Title can contain up to 32 characters.": "Rubriken kan innehålla upp till 32 tecken.",
        "Content can contain up to 1024 characters.": "Innehållet kan innehålla upp till 1024 tecken.",
        "Content can contain up to 64 characters.": "Innehållet kan innehålla upp till 64 tecken.",
        "Report is required.": "Rapport krävs.",
        "ID is required.": "ID krävs.",
        "The office does not exist.": "Kontoret finns inte.",
        "Office name": "Kontorsnamn",
        "The Temp Key does not exist.": "Tempnyckeln finns inte.",
        "autolock time": "autolåst tid",
        "The User does not exist.": "Användaren finns inte.",
        "The Installer does not exist.": "Installatören finns inte.",
        "The Project does not exist.": "Projektet finns inte.",
        "The Distributor does not exist.": "Distributören finns inte.",
        "The Community Device does not exist.": "Gemeenskapsenheten finns inte.",
        "The Property Manager does not exist.": "Fastighetsförvaltaren finns inte.",
        "The Sub Distributor does not exist.": "Underdistributören finns inte.",
        "The Single Slave does not exist.": "Enskild slav finns inte.",
        "The Property Manager EndUser does not exist.": "Fastighetsförvaltare slutanvändaren finns inte.",
        "The Family Member does not exist.": "Familjemedlemmen finns inte.",
        "Set Failed!": "Inställningen misslyckades!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "Du har nått gränsen för 10 koder inom 30 minuter. Försök igen senare.",
        "This Email doesn\'t exist.": "E-postadressen finns inte.",
        "detection type": "detekteringstyp",
        "Device UUID": "Enhet UUID",
        "smart lock device": "smartlås-enhet",
        "You are trying too often, please try again in 5 minutes.": "För många försök, prova igen om 5 minuter.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Du kan bara importera en fil åt gången. Vänta tills den aktuella importen är klar.",
        "NVR Name": "NVR-namn",
        "NVR Address": "NVR-adress",
        "Stay Alarm": "Närvarolarm",
        "Happended On": "Inträffade den",
        "Edit Milesight NVR": "Redigera Milesight NVR",
        "Add Milesight NVR": "Lägg till Milesight NVR",
        "Auto-record video on motion detection, package detection": "Spela in video automatiskt vid rörelse- eller paketdetektering",
        "A 7-day free trial is included with your subscription.": "Ett 7-dagars gratisprov ingår i ditt abonnemang.",
        "For service renewal, please reach out to your provider.": "För förnyelse av tjänsten, kontakta din leverantör.",
        "Allow the Property Manager to view recorded videos": "Tillåt fastighetsförvaltaren att se inspelade videor",
        "Please ensure the WiFi network is working properly.": "Vänligen säkerställ att WiFi-nätverket fungerar korrekt.",
        "Edit akubela Smart Locks": "Redigera akubela smartlås",
        "Upgraded Successfully!": "Uppgradering lyckades!",
        "Upgraded Failed!": "Uppgradering misslyckades!",
        "Editing...": "Redigerar...",
        "Edited successfully!": "Redigering lyckades!",
        "Edited Failed!": "Redigering misslyckades!",
        "Downloading video...": "Laddar ner video...",
        "All Locks": "Alla lås",
        "Select Locks": "Välj lås",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "{0}-siffrig PIN-kod kan användas när akubela smartlås är anslutet till nätverket. Observera att det kan ta en kort stund innan PIN-koden träder i kraft efter synkronisering.",
        "Please at least select a door or a lock.": "Vänligen välj minst en dörr eller ett lås.",
        "This lock has already been added to your apartment.": "Detta lås har redan lagts till i din lägenhet.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Detta lås har redan lagts till i en annan lägenhet, kontakta din tjänsteleverantör för hjälp.",
        "LockBody Version": "Låshus-version",
        "Two-factor Authentication": "Tvåfaktorsautentisering",
        "Monitoring Scope": "Övervakningsområde",
        "Stay Duration": "Uppehållstid",
        "Volume Settings": "Volyminställningar",
        "get card list for lock error": "fel vid hämtning av kortlista för lås",
        "get card list parse fail": "misslyckades med att tolka kortlista",
        "get pin list for lock error": "fel vid hämtning av pinkodlista för lås",
        "get pin list parse fail": "misslyckades med att tolka pinkodlista",
        "fingerprint code must be less than 2048 characters or empty.": "fingeravtryckskoden måste vara mindre än 2048 tecken eller tom.",
        "Personnel not in office.": "Personal ej på plats.",
        "customize form fail.": "det gick inte att anpassa formuläret.",
        "smart lock type error.": "fel på smart låstyp.",
        "invalid client id or secret": "ogiltigt klient-ID eller hemlighet",
        "invalid account or password": "ogiltigt konto eller lösenord",
        "invalid access token": "ogiltig åtkomsttoken",
        "invalid refresh token": "ogiltig uppfriskningstoken",
        "no permission to access this project": "ingen behörighet att komma åt detta projekt",
        "Stay Alarm Time": "Tid för kvarhållningslarm",
        "This function only support sl20 lock.": "Denna funktion stöder endast sl20-lås.",
        "Json marshal error.": "Json serialiseringsfel.",
        "Json unmarshal error.": "Json deserialiseringsfel.",
        "Illegal request, not added within valid time.": "Otillåten begäran, ej tillagd inom giltig tid.",
        "invalid nvr type": "ogiltig nvr-typ",
        "project is empty": "projektet är tomt",
        "project type is invalid": "projektets typ är ogiltig",
        "owner is invalid": "ägaren är ogiltig",
        "url is invalid": "url är ogiltig",
        "password is invalid": "lösenordet är ogiltigt",
        "building is invalid": "byggnaden är ogiltig",
        "fail to get data": "misslyckades med att hämta data",
        "invalid allow pm view type": "ogiltig pm-vytyp tillåten",
        "Data not exist.": "Data finns inte.",
        "cannot find community PrivateKey.": "kan inte hitta gemenskapens privata nyckel.",
        "cannot find single PrivateKey.": "kan inte hitta enskild privat nyckel.",
        "The third party not exist.": "Tredje part existerar inte.",
        "{0} and indoor monitors/guard phones": "{0} och inomhusdisplayer/vakttelefoner",
        "{0} and indoor monitors/guard phones, with phone as backup": "Samtal till {0} och inomhusdisplayer/vakttelefoner, vid inget svar ring mobilnumret",
        "Indoor monitors/guard phones with {0} as backup": "Samtal till inomhusdisplay/vakttelefon, vid inget svar ring {0}",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Samtal till inomhusdisplay/vakttelefon, vid inget svar ring {0}, till sist mobilnummer",
        "{0} Intercom Feature": "{0} Intercom-funktion",
        "Capture on {0}": "Skärmdump på {0}",
        "{0} Intercom Feature is not activated or has expired.": "{0} intercom-funktionen är inte aktiverad eller har löpt ut.",
        "fingerprint code must be equal 1620 characters or empty.": "fingeravtryckskoden måste vara exakt 1620 tecken eller tom.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "För att säkerställa en lyckad uppgradering, se till att låsets batterinivå är över 40 % innan du fortsätter.",
        "Automatic Locking Time": "Automatisk låsningstid",
        "WiFi Keep-Alive": "WiFi-hållning aktiv",
        "WiFi Setting": "WiFi-inställning",
        "Connecting the network...": "Ansluter till nätverket...",
        "Set successfully!": "Inställning klar!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Offline-koden kan användas även om låset inte är anslutet till WiFi.",
        "Enabling this feature will increase the lock\'s power consumption.": "Att aktivera denna funktion ökar låsets strömförbrukning.",
        "Each offline code can only be used once.": "Varje offline-kod kan endast användas en gång.",
        "Receiver Info": "Mottagarinformation",
        "log id": "loggnings-id",
        "Create HW SN Config Empty SN.": "Skapade HW SN-konfiguration med tomt SN.",
        "The SN": "Serienummer",
        "SN can contain up to 32 characters.": "SN kan innehålla upp till 32 tecken.",
        "Check HW SN Not Found.": "HW SN hittades inte.",
        "the end user not found": "slutanvändare hittades inte",
        "Family Call": "Familjesamtal",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Under uppgraderingen kommer alla låsrelaterade funktioner att vara tillfälligt otillgängliga.",
        "8-digit PIN code starting with \"9\" is invalid!": "8-siffrig PIN-kod som börjar med \"9\" är ogiltig!",
        "Lock name length must be between 1 and 50": "Låsnamnet måste vara mellan 1 och 50 tecken",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Antalet personer med fastnätsservice får inte överstiga antalet med {0} intercom.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Antalet administratörer med fasttelefonitjänst får inte överstiga antalet med {0} intercom-tjänst.",
        "charge type": "avgiftstyp",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Antalet personer med fast telefonitjänst får inte överstiga antalet personer med SmartPlus Intercom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Antalet administratörer med fast telefonitjänst får inte överstiga antalet administratörer med SmartPlus Intercom.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "En läsare kan inte konfigureras för att använda både Wiegand och RS485 samtidigt.",
        "parameter error": "Parameterfel",
        "community name already exist": "Gemenskapsnamnet finns redan",
        "personnel app without intercom feature number": "Personalapp utan intercomfunktionens nummer",
        "check feature billing charge plan new error": "Fel vid kontroll av funktionsdebiteringsplan",
        "subscription not found": "Prenumeration hittades inte",
        "System setting record not found.": "Systeminställningspost hittades inte.",
        "Smart home not enabled.": "Smart hem ej aktiverat.",
        "the apt call type value is invalid.": "Värdet för uppringningstyp är ogiltigt.",
        "the ip call or sip call value is invalid.": "IP- eller SIP-uppringningsvärde är ogiltigt.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode måste vara ett 2–8-siffrigt nummer, men får inte vara ett 8-siffrigt nummer som börjar med 9 eller vara tomt.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard måste vara A-F0-9 och mindre än 16 tecken eller tomt.",
        "owner cannot be empty.": "Ägaren får inte vara tom.",
        "creator cannot be empty.": "Skaparen får inte vara tom.",
        "the creator type value is invalid": "Skapartypvärdet är ogiltigt",
        "the IsCreateByPm value is invalid": "Värdet för IsCreateByPm är ogiltigt",
        "the pinCode already exist": "pinCode finns redan",
        "the rfCard already exist": "rfCard finns redan",
        "license plate is invalid.": "Registreringsnumret är ogiltigt.",
        "owner info is invalid.": "Ägarinformationen är ogiltig.",
        "uhf is invalid.": "uhf är ogiltig.",
        "time control is invalid.": "Tidstyrningsinställningen är ogiltig.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Du har nått gränsen på 5 fordonsregistreringsnummer och kan inte lägga till fler",
        "the plate already exist": "Nummerplåten finns redan",
        "the uhf already exist": "uhf finns redan",
        "empty community": "Tom gemenskap",
        "no find license Plate": "Hittar ej registreringsskylt",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess-läge måste vara 0, 1 eller 2.",
        "Run field is required when mode is 1 or 2.": "Run-fältet krävs när läget är 1 eller 2.",
        "Serial field is required when mode is 2.": "Serienummerfältet krävs när läget är 2.",
        "the pin cannot be empty": "pin får inte vara tomt",
        "the rfCard cannot be empty": "rfCard får inte vara tomt",
        "the IDAccess already exist": "IDAccess finns redan",
        "the resident cannot be empty": "Boende får inte vara tom",
        "the fingerprint cannot be empty": "Fingeravtryck får inte vara tomt",
        "the face cannot be empty": "Ansikte får inte vara tomt",
        "not found pin": "pin hittades inte",
        "not found rfCard": "rfCard hittades inte",
        "not found IDAccess": "IDAccess hittades inte",
        "not found fingerprint": "Fingeravtryck hittades inte",
        "not found face": "Ansiktet hittades inte",
        "face pic is invalid.": "Ansiktsbilden är ogiltig.",
        "community build and room cannot be empty.": "Gemenskapsbyggnad och rum får inte vara tomma.",
        "device info mac cannot be empty.": "Enhetsinfo MAC-adress får inte vara tom.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "Schemaläggartyp måste vara 0,1,2 eller så är tidsformatet ogiltigt, eller dataflaggan är inte mellan 0–127.",
        "MAC address cannot be empty.": "MAC-adressen får inte vara tom.",
        "MAC address 0C1105000000 is not allowed.": "MAC-adressen 0C1105000000 är inte tillåten.",
        "MAC address must be 12 hexadecimal characters.": "MAC-adressen måste vara 12 hexadecimala tecken.",
        "Scheduler type value is invalid.": "Schemaläggartypvärdet är ogiltigt.",
        "parse is fail": "Tolkning misslyckades",
        "the fingerprint already exist": "Fingeravtrycket finns redan",
        "the licensePlate cannot be empty": "Nummerplåten får inte vara tom",
        "the licensePlate already exist": "Nummerplåten finns redan",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run måste vara ett 10-siffrigt nummer eller sluta med -K.",
        "idaccess serial must be 9 digit number.": "idaccess serienummer måste vara ett 9-siffrigt nummer.",
        "relay not in 0-15": "Relä är inte mellan 0–15",
        "security relay not in 0-3": "Säkerhetsrelä är inte mellan 0–3",
        "file name is wrong": "Filnamnet är felaktigt",
        "access mode specified": "Åtkomstläge angivet",
        "create community user accessmode failed.": "Skapande av användartillgångsläge för gemenskap misslyckades.",
        "delete community user accessmode failed.": "Borttagning av användartillgångsläge för gemenskap misslyckades.",
        "Cannot delete building because it has associated users.": "Kan inte ta bort byggnaden eftersom den har associerade användare.",
        "Cannot delete building because it has associated Salto devices.": "Kan inte ta bort byggnaden eftersom den har associerade Salto-enheter.",
        "community building not found": "Gemenskapsbyggnad hittades inte",
        "Invalid Name Display": "Ogiltig namnvisning",
        "The Community does not exist.": "Gemenskapen existerar inte.",
        "Update CommunityIsInstallerKit Error.": "Fel vid uppdatering av CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "Återförsäljaren stöder inte gemenskapsanrop-fel.",
        "Community Has Special Device, Not Allowed To Delete.": "Gemenskapen har en speciell enhet, borttagning är inte tillåten.",
        "The project smart home switch must be disabled": "Projektets smarta hemströmbrytare måste inaktiveras",
        "There are ITec Locks in project": "Det finns ITec-lås i projektet",
        "There are Salto Locks in project": "Det finns Salto-lås i projektet",
        "There are Dormakaba Locks in project": "Det finns Dormakaba-lås i projektet",
        "It is rent manager project": "Detta är ett rent manager-projekt",
        "It is installer account": "Detta är ett installatörskonto",
        "contact preference type": "uppringningspreferenstyp",
        "Floor list is required when not all floors.": "Våningslista krävs om det inte gäller alla våningar.",
        "Building floors list is required when all buildings.": "Lista över byggnadsvåningar krävs när det gäller alla byggnader.",
        "Indoor monitor name is required.": "Inomhusmonitorens namn krävs.",
        "The primary account is not activated.": "Huvudkontot är inte aktiverat.",
        "You can\'t create more family member accounts.": "Du kan inte skapa fler familjemedlemskonton.",
        "community user not found": "Gemenskapsanvändare hittades inte",
        "community is empty": "Gemenskapen är tom",
        "the end user not master user": "Slutanvändaren är inte huvudkontots användare",
        "the end user not member user": "Slutanvändaren är inte medlemsanvändare",
        "The email already exists and cannot be repeated": "E-postadressen finns redan, kan inte upprepas",
        "The mobile Number already exists": "Mobilnumret finns redan",
        "The room number format error.": "Fel i rumsnummerformat.",
        "community not found": "Gemenskap hittades inte",
        "resident not found": "Boende hittades inte",
        "installer not found": "Installatör hittades inte",
        "Operation Failed!": "Åtgärden misslyckades!",
        "You don\'t have operate permission": "Du har inte behörighet att utföra denna åtgärd",
        "You cannot select Relay and Door at the same time": "Du kan inte välja Relä och Dörr samtidigt",
        "user don\'t active": "Användaren är inte aktiv",
        "User has expired": "Användaren har löpt ut",
        "timestamp must be within 3 minutes of current server time": "Tidsstämpeln måste vara inom tre minuter från aktuell servertid",
        "cannot find single rf Card.": "Kan inte hitta en enskild rf Card.",
        "cannot find community rf Card.": "Kan inte hitta gemenskapens rf Card.",
        "smartLock model": "smart-låsmodell",
        "the project does not open smart home": "Projektet har inte aktiverat smart hem",
        "php web server error": "php webserver-fel",
        "Ins not found.": "Ins hittades inte.",
        "RentManage Unit Not Set.": "RentManage-enhet är inte inställd.",
        "add audit log error": "Fel vid tillägg av granskningslogg",
        "check building in error": "Fel vid kontroll av byggnad",
        "Special devices cannot be deleted": "Specialenheter kan inte tas bort",
        "the email is empty": "E-post är tom",
        "the email format is incorrect": "E-postformatet är felaktigt",
        "the mobile number is empty": "Mobilnummer är tomt",
        "the mobile number format is incorrect": "Fel format på mobilnummer",
        "Site not found": "Projekt hittades inte",
        "User not found": "Användare hittades inte",
        "invalid time format": "Ogiltigt tidsformat",
        "ground floor type": "bottenvåningsformat",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Felaktigt startvåningsintervall, giltiga värden är -10 till -1, G0, G1, G2, 1 till 128.",
        "Building ID must be between 1 and 99.": "Byggnads-ID måste vara mellan 1 och 99.",
        "Community building name": "Gemenskapsbyggnadsnamn",
        "Building ID already exists in this community.": "Byggnads-ID finns redan i denna gemenskap.",
        "building ID": "byggnads-ID",
        "Community building not found.": "Gemenskapsbyggnad hittades inte.",
        "Cannot delete building because it has associated devices.": "Kan inte ta bort byggnaden eftersom den har anslutna enheter.",
        "project is not valid": "Projektet är inte giltigt",
        "Cannot delete building because it has associated salto devices.": "Kan inte ta bort byggnaden eftersom den har anslutna Salto-enheter.",
        "Cannot delete building because it has associated iTec devices.": "Kan inte ta bort byggnaden eftersom den har anslutna iTec-enheter.",
        "Cannot delete building because it has associated dormakaba devices.": "Kan inte ta bort byggnaden eftersom den har anslutna dormakaba-enheter.",
        "member limit num": "Medlemsbegränsningsantal",
        "Indoor Monitor No Set Error.": "Inomhusmonitor ej inställd fel.",
        "The room not has indoor": "Rummet har ingen inomhusenhet",
        "check user in building error": "kontrollera användare i byggnadsfel",
        "The name specified is already in use.": "Det angivna namnet används redan.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Denna tidsperiod överlappar med en befintlig. Vänligen justera den.",
        "This door status changed. Please try again.": "Dörrens status har ändrats. Försök igen.",
        "the lock can\'t bind this community": "Låset kan inte binda denna gemenskap.",
        "The custom quantity limit has been exceeded!": "Den anpassade kvantitetsgränsen har överskridits!",
        "This time span overlaps with an existing one. Please adjust it.": "Denna tidsperiod överlappar med en befintlig. Vänligen justera den.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Denna engångsschemaläggning överlappar med en befintlig engångsschemaläggnings giltighetstid. Vänligen justera den.",
        "Operation Failed. Please try again.": "Åtgärden misslyckades. Försök igen.",
        "The image is not a front view.": "Bilden är inte en framifrånvy.",
        "A mask was detected.": "En mask har upptäckts.",
        "The image resolution is too low.": "Bildens upplösning är för låg.",
        "No face was detected.": "Inget ansikte upptäcktes.",
        "The file size is too large.": "Filstorleken är för stor.",
        "The face in the image is too large.": "Ansiktet på bilden är för stort.",
        "The face in the image is too small.": "Ansiktet på bilden är för litet.",
        "Multiple faces detected.": "Flera ansikten upptäckta.",
        "The face is not clear enough.": "Ansiktet är inte tillräckligt tydligt.",
        "Face detection failed.": "Ansiktsdetektering misslyckades.",
        "Please enter a value between 1 and 9999": "Ange ett värde mellan 1 och 9999",
        "Please select which input your door sensor is connected to.": "Vänligen välj vilken ingång din dörrsensor är ansluten till.",
        "Add temp key failed, please try it again": "Lägg till tillfällig nyckel misslyckades, vänligen försök igen",
        "Dis Not Support Dynamic QRCode Error.": "Stöder inte dynamisk QR-kodfel.",
        "QR code not exist": "QR-kod existerar inte",
        "The temp key has expired.": "Den temporära nyckeln har gått ut.",
        "The device is not in the office": "Enheten är inte på kontoret",
        "The device is already assigned.": "Enheten är redan tilldelad.",
        "The device cannot be assigned to any user.": "Enheten kan inte tilldelas någon användare.",
        "You cannot select an option with fewer users than the current project members.": "Du kan inte välja ett alternativ med färre användare än nuvarande projektmedlemmar.",
        "File check failed. Please download the latest template and try again.": "Filkontroll misslyckades. Vänligen ladda ner den senaste mallen och försök igen.",
        "Dynamic QR Code not active.": "Dynamisk QR-kod inte aktiv.",
        "Dynamic QR Code not enable.": "Dynamisk QR-kod inte aktiverad.",
        "{0} not found.": "{0} hittades inte.",
        "Tier charge plan": "Stegvis avgiftsplan",
        "Feature billing charge plan new": "Funktion faktureringsavgiftsplan ny",
        "Feature billing gradient charge plan": "Funktionell fakturering gradientavgiftsplan",
        "The exit time cannot be earlier than the entry time.": "Utgångstiden kan inte vara tidigare än inpasseringstiden.",
        "User Name or Password": "Användarnamn eller lösenord",
        "You can only link up to 5 sites.": "Du kan bara länka upp till 5 projekt.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Denna registreringsskylt är redan registrerad på en boende och kan inte läggas till i spärrlistan.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Denna registreringsskylt är svartlistad och kan inte registreras som ett fordon.",
        "Elevator not configured in company access floor.": "Hissen är inte konfigurerad på företagets åtkomstvåning.",
        "the device is not in the office": "enheten är inte på kontoret",
        "A maximum of 1000 data items can be imported": "Högst 1000 dataposter kan importeras",
        "Exit time cannot be later than the current time.": "Utgångstiden kan inte vara senare än aktuell tid.",
        "You can only import a file at a time in the current parking lot.": "Du kan bara importera en fil åt gången i det aktuella parkeringsområdet.",
        "The license plate is already in the blocklist.": "Registreringsskylten finns redan i spärrlistan.",
        "Building name too long.": "Byggnadsnamnet är för långt.",
        "Unlock failed. Permission denied by user.": "Upplåsning misslyckades. Behörighet nekades av användaren.",
        "Please remove the sensor device(s) before disabling this feature.": "Ta bort sensorenheten/-erna innan du inaktiverar den här funktionen.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Åtgärden misslyckades! Den dagliga gränsen på 15 poster har överskridits för denna användare.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Upp till {0} offentliga enheter kan läggas till per projekt. Kontakta Akuvox Technical Support på support{'@'}akuvox.com om du vill lägga till fler.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Upp till {0} personalkonton kan läggas till per projekt. Kontakta Akuvox Technical Support på support{'@'}akuvox.com om du vill lägga till fler.",
        "cancel": "Stäng",


    }
};
